import MultipleStopOutlinedIcon from "@mui/icons-material/MultipleStopOutlined"
import Autocomplete from "@mui/material/Autocomplete"
import CircularProgress from "@mui/material/CircularProgress"
import InputAdornment from "@mui/material/InputAdornment"
import TextField from "@mui/material/TextField"
import { useState } from "react"

import { useLoadCRMStages } from "../utils"

export default function CRMStageAutocomplete({
  crmStage,
  setCRMStage,
  crmStageInputValue,
  setCRMStageInputValue,
  crmStages,
  isLoadingCRMStages,
  textFieldVariant = "outlined",
  disabled = false,
}) {
  return (
    <Autocomplete
      disabled={disabled}
      inputValue={crmStageInputValue}
      onInputChange={(e, newValue) => setCRMStageInputValue(newValue)}
      value={crmStage}
      onChange={(e, newValue) => setCRMStage(newValue)}
      options={crmStages}
      getOptionLabel={(option) => option.name || ""}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(props) => (
        <TextField
          variant={textFieldVariant}
          {...props}
          label="Hiring Stage"
          InputProps={{
            ...props.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <MultipleStopOutlinedIcon />
              </InputAdornment>
            ),
            endAdornment: isLoadingCRMStages ? (
              <InputAdornment position="end">
                <CircularProgress
                  color="inherit"
                  variant="indeterminate"
                  thickness={2}
                  size={12}
                />
              </InputAdornment>
            ) : (
              props.InputProps.endAdornment
            ),
          }}
        />
      )}
    />
  )
}

export function useCRMStageAutocompleteState() {
  const [crmStage, setCRMStage] = useState(null)
  const [crmStageInputValue, setCRMStageInputValue] = useState("")
  const { crmStages, isLoadingCRMStages, loadCRMStages } = useLoadCRMStages()

  function populateCurrentCRMStage(candidate) {
    loadCRMStages().then((data) => {
      const candidateCRMStage = data.filter(
        (crmStage) => crmStage.id === candidate.crm_stage.id
      )[0]
      setCRMStage(candidateCRMStage)
      setCRMStageInputValue(candidateCRMStage.name)
    })
  }

  return {
    crmStage,
    setCRMStage,
    crmStageInputValue,
    setCRMStageInputValue,
    crmStages,
    isLoadingCRMStages,
    populateCurrentCRMStage,
  }
}
